import React from 'react';
import PropTypes from 'prop-types';

import {
  QuestionLabel,
  Container,
  Label,
} from '../styles';

const RankingQuestionType = (props) => {
  const {
    label,
    index,
    optionAnswers,
  } = props;

  const sortedOptionAnswers = optionAnswers.sort((a, b) => a.order - b.order);

  return (
    <Container>
      <QuestionLabel>{`Question ${index + 1}: ${label} (Ranking)`}</QuestionLabel>
      {optionAnswers && sortedOptionAnswers.map((answer, i) => (
        <Label key={answer}>
          {`${i + 1} - ${answer.label}`}
        </Label>
      ))}
    </Container>
  );
};

RankingQuestionType.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  optionAnswers: PropTypes.instanceOf(Array).isRequired,
};

export default RankingQuestionType;
